import { getRow, insertRow, updateRow, subscribeRow } from '../lib/db';
import { SystemSettings } from '../types';

const DEFAULT_SETTINGS: Omit<SystemSettings, 'userId' | 'updatedAt'> = {
  ai: {
    pipeline: [
      { providerId: 'gemini', enabled: true, priority: 1 },
      { providerId: 'openai', enabled: true, priority: 2 }
    ]
  }
};

export const getSystemSettings = async (userId: string): Promise<SystemSettings> => {
  const existing = await getRow<SystemSettings>('settings', userId, 'userId');
  if (existing) return existing;

  const newSettings: SystemSettings = {
    userId,
    ...DEFAULT_SETTINGS,
    updatedAt: new Date().toISOString()
  };
  await insertRow('settings', newSettings as unknown as Record<string, unknown>);
  return newSettings;
};

export const updateSystemSettings = async (userId: string, updates: Partial<SystemSettings>): Promise<void> => {
  await updateRow('settings', userId, {
    ...updates,
    updatedAt: new Date().toISOString()
  }, 'userId');
};

export const subscribeToSettings = (userId: string, callback: (settings: SystemSettings) => void) => {
  return subscribeRow<SystemSettings>('settings', 'userId', userId, (row) => {
    if (row) {
      callback(row);
    } else {
      callback({
        userId,
        ...DEFAULT_SETTINGS,
        updatedAt: new Date().toISOString()
      });
    }
  });
};
